document.addEventListener('DOMContentLoaded', function () {
  var tracks = document.querySelectorAll('.new-landing-reviews__scroll');

  tracks.forEach(function (track) {
    var isDown = false;
    var didDrag = false;
    var startX = 0;
    var startScrollLeft = 0;

    track.addEventListener('pointerdown', function (event) {
      if (event.pointerType !== 'mouse') return;
      isDown = true;
      didDrag = false;
      startX = event.clientX;
      startScrollLeft = track.scrollLeft;
      track.classList.add('is-dragging');
    });

    track.addEventListener('pointermove', function (event) {
      if (!isDown) return;
      var delta = event.clientX - startX;
      if (Math.abs(delta) > 3) didDrag = true;
      track.scrollLeft = startScrollLeft - delta;
    });

    function stopDrag() {
      isDown = false;
      track.classList.remove('is-dragging');
    }

    track.addEventListener('pointerup', stopDrag);
    track.addEventListener('pointerleave', stopDrag);
    track.addEventListener('pointercancel', stopDrag);

    track.addEventListener(
      'click',
      function (event) {
        if (didDrag) {
          event.preventDefault();
          event.stopPropagation();
        }
      },
      true
    );
  });
});
